import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectZipCode } from '../reducers/zipCodeReducer';
import useFetchOffers from '../hooks/useFetchOffers';
import { offersDagLoad } from '../utils/analyticsEventListeners';
import OffersList from './OffersList';
import { useValidateZipCode } from '../hooks/useValidateZipCode';
import { setOffers } from '../reducers/offersReducer';
import useFetchCanOffers from '../hooks/useFetchCanOffers';

const Offers: React.FC = () => {
  const dispatch = useDispatch();

  const { confirmedZipcode, market } = useSelector(selectZipCode);

  const { loading, offers } = useFetchOffers(confirmedZipcode);
  const { caOffers, loadingCaOffers } = useFetchCanOffers();

  const isLoading = loading || loadingCaOffers;

  const confirmedZipFromSessionStorage =
    typeof sessionStorage !== 'undefined' ? sessionStorage.getItem('validZipCode') : null;

  const { setAlreadyValidZip } = useValidateZipCode();

  const isCaMarket = market === 'CA';

  // Saving offers to Redux
  useEffect(() => {
    if (offers && !isCaMarket) dispatch(setOffers(offers));
    if (caOffers && isCaMarket) dispatch(setOffers(caOffers));
  }, [dispatch, offers, caOffers, isCaMarket]);

  // Saving zip to redux
  useEffect(() => {
    if (confirmedZipFromSessionStorage) {
      setAlreadyValidZip(confirmedZipFromSessionStorage);
    }
  }, [confirmedZipFromSessionStorage, setAlreadyValidZip]);

  // Sending dag event to IXIS
  useEffect(() => {
    if (!offers?.length) return;
    const ixisEvent = {
      dealerAdGroup: offers[0].zipClusterID,
      visitorZipCode: confirmedZipcode,
    };
    offersDagLoad(ixisEvent);
  }, [confirmedZipcode, offers]);

  return <OffersList loading={isLoading} />;
};

export default Offers;
